import React, { useEffect, useState } from 'react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import Flex from '../../commons/Flex/Flex'
import IndicatorManagerial from '../../commons/indicatorManagerial/IndicatorManagerial'
import Text from '../../commons/Text/Text'
import styles from './extractDetailThree.scss'

if (process.env.NODE_ENV !== 'test') {
  Modal.setAppElement('#app')
}

const ExtractDetailThree = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const { data } = useSelector(
    (state) => state.extractReducer.extractLevelThree
  )

  useEffect(() => {
    if (data.length) {
      setVisible(true)
    }
  }, [data])

  function handleClose() {
    dispatch(reducks.resources.extract.actions.clearExtractLevelThree())
    setVisible(false)
  }

  return (
    <Modal
      isOpen={visible}
      className="react-modal-content"
      overlayClassName="react-modal-overlay"
      testId="modal-indicator-three"
    >
      <Flex justifyContent="space-between">
        <Text
          value="Detalhe Faturamento Recorrente"
          size="md"
          color="gray"
          variation="dark"
          extraBold
        />
        <button
          type="button"
          onClick={handleClose}
          title="Fechar modal"
          className={styles.modalButton}
        >
          <MdClose color="#4D4D4D" size={25} />
        </button>
      </Flex>
      <Flex column margin="20px 0px 0px 0px">
        {data.map((indicator) => (
          <IndicatorManagerial
            key={indicator.identifier}
            title={indicator.name}
            updatedAt={indicator.referenceAt}
            current={indicator.value}
            previous={indicator.valuePenult}
            minimum={indicator.valueMinimum}
            formatId={indicator.formatId}
            periodicityName={indicator?.periodicityName}
            margin="0 20px 20px 0"
            height="220px"
            width="100%"
          />
        ))}
      </Flex>
    </Modal>
  )
}

export default ExtractDetailThree
